import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { ModelContext, SettingsContext } from "../context";
import ModalPopup from "../Modal";
import AccordionItem from "./AccordionItem";
import AnnotationList from "./AnnotationList";
import AnimationList from "./AnimationList";
import AnimationSettings from "./AnimationSettings";
import HotSpotInsctance from "./HotspotInstance";

function AnimationPage() {
  const { drawHotSpotFromData, getPoints } = useContext(ModelContext);
  const {
    authenticationToken,
    sceneActive,
    editorProductInfo,
    animations,
    setAnimations,
    getAnimationAnnotationList,
  } = useContext(SettingsContext);
  const [animationSpeed, setAnimationSpeed] = useState("1.0");
  const [animationType, setAnimationType] = useState("0");
  const [modelViewer, setModelViewer] = useState();
  const [elements, setElements] = useState([]);
  const [selectedAnimationName, setSelectedAnimationName] = useState(
    "Default Animation Name"
  );
  const [dataObject, setDataObject] = useState();

  const [animationPosition, setAnimationPosition] = useState();
  const [animationNormal, setAnimationNormal] = useState();

  useEffect(() => {
    let viewer = document.getElementById("modelViewer");
    setModelViewer(viewer);
  }, []);

  const handleHotSpot = async () => {
    let scene = modelViewer.scene();
    HotSpotInsctance.bind(modelViewer, scene, true);
    modelViewer.addEventListener("click", drawAnimationHotspot);
  };

  const drawAnimationHotspot = () => {
    modelViewer.removeEventListener("click", drawAnimationHotspot);
    const { position, normal } = getPoints();
    setAnimationPosition(position);
    setAnimationNormal(normal);

    let dataObject = {
      type: 1,
      position: position?.toString(),
      direction: normal?.toString(),
      animationName: selectedAnimationName,
      animationType: animationType,
      animationSpeed: animationSpeed,
      productId: editorProductInfo.id,
      //distance: "1.0"
    };

    let element = drawHotSpotFromData(dataObject);
    elements.push(element);
    setDataObject(dataObject);
  };

  const saveAnimation = async () => {
    let dataObject = {
      type: 1,
      position: animationPosition?.toString(),
      direction: animationNormal?.toString(),
      animationName: selectedAnimationName,
      animationType: animationType,
      animationSpeed: animationSpeed,
      productId: editorProductInfo.id,
      //distance: "1.0"
    };

    document.dispatchEvent(
      new CustomEvent("open-editor-popup", { detail: "Animasyon ekleniyor..." })
    );
    axios
      .post(
        process.env.REACT_APP_BACKEND_API + `annotation/saveAnimation`,
        dataObject,
        {
          headers: {
            Authorization: authenticationToken,
          },
        }
      )

      .then(
        (res) => {
          document.dispatchEvent(
            new CustomEvent("update-editor-popup", {
              detail: "Animasyon eklendi...",
            })
          );

          document.dispatchEvent(new CustomEvent("close-editor-popup"));
          setAnimationPosition(null);
          setAnimationNormal(null);
          getAnimationAnnotationList(editorProductInfo.id);
        },
        (rej) => {
          document.dispatchEvent(
            new CustomEvent("update-editor-popup", {
              detail: "Animasyon Eklenemedi",
            })
          );
          document.dispatchEvent(new CustomEvent("close-editor-popup"));
        }
      );
  };

  return (
    <AccordionItem header="Animation">
      <div className="editor-panel">
        <AnimationSettings
          setAnimationSpeed={setAnimationSpeed}
          setAnimationType={setAnimationType}
          animationType={animationType}
          animationSpeed={animationSpeed}
          elements={elements}
        />

        <AnimationList
          animationSpeed={animationSpeed}
          animationType={animationType}
          modelViewer={modelViewer}
          setSelectedAnimationName={setSelectedAnimationName}
        />

        <AnnotationList header="Saved Animation Hotspots" listType={1} />

        <div>
          <button
            className="saveButton"
            style={{ float: "left" }}
            onClick={() => handleHotSpot()}
          >
            <i className="dot circle outline icon" />
            Position
          </button>
        </div>

        <div>
          <button
            className="saveButton"
            style={{ float: "left" }}
            onClick={() => {
              saveAnimation();
            }}
          >
            <i className="save icon" />
            Save
          </button>
        </div>
      </div>
    </AccordionItem>
  );
}

export default AnimationPage;
